export default "__VITE_ASSET__DL6wsqPt__"